// Widget Scripts
import mainSlider from './js/widgets/mainSlider.js';
import autoEventFeed from './js/widgets/eventsWidget.js';
import cardsWidget from './js/widgets/cardsWidget.js';
import seoWidget from './js/widgets/seoWidget.js';
import customSignupWidget from './js/widgets/signupWidget.js';
import videoWidget from './js/widgets/videoWidget.js';
// Custom Theme Scripts
import './js/localjs.js';
// Aos Library
import AOS from 'aos';
import 'aos/dist/aos.css';

// Initialize Homepage Widgets

$(document).ready(function () {
  // Initialize Custom Theme Scripts
  if (globalThis.location.pathname === '/') {
    mainSlider();
    seoWidget();
    cardsWidget();
    videoWidget();
    autoEventFeed();
  }
  customSignupWidget();
});

$(window).on('load', function () {
  setTimeout(() => {
    AOS.init({
      anchorPlacement: 'bottom-bottom',
      animatedClassName: 'aos-animate',
      initClassName: 'aos-init',
    });
  }, 2000);
});
